import { defineComponent as _defineComponent } from 'vue'
interface NavigationDrawerEntry {
  title: string,
  route: { 
    name: string
  },
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationDrawer',
  setup(__props) {


const items: NavigationDrawerEntry[] = [
  {
    title: 'Stores',
    route: { name: 'stores' },
  },
  {
    title: 'My Access Tokens',
    route: { name: 'pats' },
  }
]


return { __sfc: true,items }
}

})